function Footer() {
    return (
      <footer style={{ background: "#003366", color: "white", padding: "10px", textAlign: "center" }}>
        &copy; {new Date().getFullYear()} SLD Petroleum Fuel Enterprises. All rights reserved.
      </footer>
    );
  }
  export default Footer;